exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menuItemHead[data-v-190f786b] {\n  font-size: 16px;\n  margin-bottom: 10px;\n}\n.menuItemTitle[data-v-190f786b] {\n  color: #ddd;\n}\n.menuItemSubBar[data-v-190f786b] {\n  width: 40px;\n  height: 5px;\n  margin-top: 8px;\n  border-radius: 15%;\n  background-color: var(--actionButtonColor);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-190f786b","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/menus/MobileMenuComponents/MobileMenuSectionHeader.vue
// module id = 1540
// module chunks = 2